import {Component} from "@angular/core";
import {
  AlertController,
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import {Api} from "../../services/api";
import {Util} from "../../services/util";
import {BindAccountPage} from "../bind-account/bind-account";
import {WeixinQr} from "../../services/weixin_qr";
import {ShareCard} from "../../services/sharecard";

declare var WeixinJSBridge;

@IonicPage({
  segment: "reseller-payment-link/:uid",
})
@Component({
  selector: "page-reseller-payment-link",
  templateUrl: "reseller-payment-link.html",
})
export class ResellerPaymentLinkPage {
  JSON = JSON;

  data = {
    paymentLink: null,
    itemDescription: null,
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private api: Api,
    private util: Util,
    public weixinQr: WeixinQr,
    private shareCard: ShareCard
  ) {
  }

  getTitle() {
    try {
      return this.data.paymentLink.reseller_payment_link_template.title;
    } catch (ex) {
      return "订单支付";
    }
  }

  ionViewDidEnter() {
    this.api.getResellerPaymentLink(this.navParams.data.uid).then((data) => {
      this.data.paymentLink = data;
      document.title = this.getTitle();
      this.data.itemDescription = {
        how_to_use_html: data.reseller_payment_link_template.how_to_use_html,
        samples: data.reseller_payment_link_template.samples || "[]",
        description_html: data.reseller_payment_link_template.description_html,
      };

      this.shareCard.share({
        title: this.getTitle(),
        desc: data.purchase_button_text,
        link: location.href,
        imgUrl: extractFirstImageSrc(data.reseller_payment_link_template.description_html),
      });

    });
  }

  pay() {
    this.assertIsWechatAndLoggedIn();

    if (!window["UserService"].user_center_user_id) {
      this.util.showToast("请先完成手机号绑定，再进行购买");
      window["bindAccountCallback"] = this.pay.bind(this);
      this.navCtrl.push(BindAccountPage);
      return;
    }

    this.api
      .payResellerPaymentLink(this.navParams.data.uid)
      .then((orderInfo) => {
        const {weixinPayParams, orderId, resellerOrderId} = orderInfo;
        const onWeixinPayOk = () => {
          this.pollOrderStatus(orderId, () => {
            this.alertCtrl
              .create({
                title: "支付成功",
                buttons: [
                  {
                    text: "确定",
                    cssClass: "font-weight-normal",
                    role: "cancel",
                  },
                ],
              })
              .present();
            localStorage["showQrForResellerOrder"] = resellerOrderId;
            setTimeout(() => {
              window.location.hash =
                "/reseller-order-detail/" + resellerOrderId;
            }, 1000);
          });
        };
        const onBridgeReady = () => {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            weixinPayParams,
            (res) => {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                onWeixinPayOk();
              } else {
                alert(JSON.stringify(res));
              }
            }
          );
        };

        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          }
        } else {
          onBridgeReady();
        }
      });
  }

  findMyOrders() {
    this.assertIsWechatAndLoggedIn();
    window.location.hash = "/reseller-order-list";
  }

  assertIsWechatAndLoggedIn() {
    if (!this.util.isWeixin() || !this.util.isAndroidOrIOS()) {
      this.alertCtrl
        .create({
          cssClass: "reseller-weixin-qr-alert",
          message: `<div>
<div>
    请使用微信打开本页面以继续
</div>
<div >
    <img src="https://server.datongbei.com/api/qr?url=${encodeURIComponent(
            window.location.href
          )}"/>
</div>
</div>`,
          subTitle: ``,
          buttons: [
            {
              text: "完成",
              cssClass: "font-weight-normal",
              role: "cancel",
            },
          ],
        })
        .present();
      throw new Error("[trivial-error] is not weixin");
    }

    if (!window["UserService"].isLoggedIn()) {
      window["UserService"].showLogin();
      throw new Error("[trivial-error] not logged in");
    }
  }

  async pollOrderStatus(orderId, successCallback) {
    let loading = this.loadingCtrl.create({
      content: "正在查询订单状态",
    });
    loading.present();
    while (true) {
      const detail = await this.api.resellerPaymentGetOrderDetail(orderId);
      if (detail.order.stage == 1) {
        setTimeout(() => {
          successCallback();
        });
        break;
      }
      await sleep(3000);
    }

    loading.dismiss();
  }
}

function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}

function extractFirstImageSrc(htmlString) {
  // Create a DOM parser
  const parser = new DOMParser();

  // Parse the input HTML string
  const doc = parser.parseFromString(htmlString, "text/html");

  // Find the first image tag
  const imgElement = doc.querySelector("img");

  // Return the image src if found, otherwise return null
  return imgElement ? imgElement.src : null;
}



// WEBPACK FOOTER //
// ./src/pages/reseller-payment-link/reseller-payment-link.ts